export const DocumentFieldLabels = {
  name: 'Name',
  attachment: 'Attachments',
  assignOwner: 'Assign Owner',
  assignTask: 'Assign Task',
  taskFiles: 'Document References',
  assignChangeOrders: 'Assign Change Orders',
  internalDocumentId: 'Internal Document Id',
  rev: 'Rev',
  descriptionOfChange: 'Description of Change',
  reasonForChange: 'Reason for Change',
  uploadNewFile: 'Upload New File'
} as const;

export type DocumentField = keyof typeof DocumentFieldLabels;

export const DocumentFields: DocumentField[] = Object.keys(
  DocumentFieldLabels
) as DocumentField[];
